import { ReactNode } from "react";
import { motion } from "framer-motion";

type Props = {
    children: ReactNode, 
    className?: string,
    amount?: number
}

export default function ScrollAnimationWrapper(
    {children, className, amount, ...props}: Props
) {
  const defaultAmount=0.2
  return (
    <motion.div
        initial={{ opacity: 0, y: 50 }} // Start hidden and out of view
        whileInView={{ opacity: 1, y: 0 }} // Animate when in view
        viewport={{ once: true, amount: amount || defaultAmount }} // Trigger when 50% of the component is visible
        transition={{ duration: 0.6 }}>
        {children}
    </motion.div>
  )
}